import { render } from "./OrderTrack.vue?vue&type=template&id=4b54bf72"
import script from "./OrderTrack.vue?vue&type=script&lang=js"
export * from "./OrderTrack.vue?vue&type=script&lang=js"

import "./OrderTrack.vue?vue&type=style&index=0&id=4b54bf72&lang=css"

import exportComponent from "/Users/ruisilva/Desktop/Projects/qmulher/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__